import { render, staticRenderFns } from "./count-down-v2.vue?vue&type=template&id=bdf0bf7a&scoped=true&"
import script from "./count-down-v2.vue?vue&type=script&lang=js&"
export * from "./count-down-v2.vue?vue&type=script&lang=js&"
import style0 from "./count-down-v2.vue?vue&type=style&index=0&id=bdf0bf7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf0bf7a",
  null
  
)

export default component.exports